export default function () {
  const res = {
    audioContext: new (window.AudioContext || window.webkitAudioContext)(),
    audios: {},
    progress: 0,
    onProgress: null,
    cancelLoad: false,
    currentAudio: null,
    queue: null,

    init: () => {
      res.queue = [];
      // res.audioSource = res.audioContext.createBufferSource();
      // res.audioSource.connect(res.audioContext.destination);
    },

    loadWordsAudio: async (words) => {
      let manifest = [
        {
          id: "intro",
          src: "/sitemedia/activity/read_sentences.mp3",
          type: "sound",
        },
      ];
      for (let w of words) {
        if (w.audio_file) {
          manifest.push({
            id: "w_" + w.id,
            src: "/media/audio/" + w.audio_file,
          });
          for (let s of w.syllables) {
            if (s.audio_file) {
              manifest.push({
                id: "syl_" + s.id,
                src: "/media/audio/" + s.audio_file,
              });
            }
          }
          for (let s of w.sentences) {
            if (s.audio_file) {
              manifest.push({
                id: "sen_" + s.id,
                src: "/media/audio/" + s.audio_file,
              });
            }
          }
        }
      }
      const audioCount = manifest.length;
      let loaded = 0;
      for (let f of manifest) {
        if (res.cancelLoad) {
          break;
        }
        try {
          const resData = await fetch(f.src);
          const arrayBuffer = await resData.arrayBuffer();
          const buffer = await res.audioContext.decodeAudioData(arrayBuffer);
          // const source = res.audioContext.createBufferSource();
          // source.buffer = buffer;
          // source.connect(res.audioContext.destination);
          res.audios[f.id] = buffer;
        } catch (error) {}
        loaded++;
        res.handleProgress({ loaded: loaded / audioCount });
      }
    },

    play: (id) => {
      res.stop();
      if (res.audios[id]) {
        const source = res.audioContext.createBufferSource();
        source.buffer = res.audios[id];
        source.connect(res.audioContext.destination);
        source.onended = res.clearCurrentAudio;
        res.currentAudio = source;
        source.onended = res.handlePlayed;
        source.start();
      }
    },

    addToQueue(id) {
      res.queue.push(id);
    },

    clearQueue() {
      res.queue = [];
    },

    stop: () => {
      if (!res.currentAudio) {
        return;
      }
      res.currentAudio.onended = null;
      res.currentAudio.stop();
      res.clearCurrentAudio();
    },

    clearCurrentAudio() {
      res.currentAudio = null;
    },

    destroy: () => {
      res.stop();
      res.cancelLoad = true;
      res.audioContext = null;
      res.audios = {};
      res.queue = [];
    },

    handleProgress: (a) => {
      if (res.onProgress) {
        res.onProgress(a.loaded);
      }
    },

    handlePlayed: () => {
      if (res.queue.length > 0) {
        res.play(res.queue.shift());
      }
      if (res.onPlayComplete) {
        res.onPlayComplete();
        res.onPlayComplete = null;
      }
    },
  };

  res.init();

  return res;
}
